import dk from '../assets/sounds/dk.mp3';
import mario from '../assets/sounds/mario.mp3';
import mario64 from '../assets/sounds/mario-64.mp3';
import marioWorldClear from '../assets/sounds/mario-world-clear.mp3';
import megaman from '../assets/sounds/megaman.mp3';
import sonic from '../assets/sounds/sonic.mp3';
import zelda from '../assets/sounds/zelda.mp3';

export default [dk, mario, mario64, marioWorldClear, megaman, sonic, zelda];
